import GroupsOverviewNuttall from '../../../../../customized/alan-nuttall-flexeserve-eu/components/GroupManager/Overview/GroupsOverview';
import { ToggleComponent } from '../../../../../featureToggle';
import GroupsOverview from './GroupsOverview';

export default ToggleComponent(GroupsOverview, {
  StyledComponentsVariants: {
    'alan-nuttall-flexeserve-eu': GroupsOverviewNuttall,
  },
});
